import Phrase from '../../libs/translationsUtils/phrase'
import { Component } from 'preact'

export default class ContentSpoiler extends Component {
  constructor (props) {
    super()
    props.parentEl.className = 'spoiler-container content-hidden'
    this.state = {
      showContent: false
    }
    this.toggleSpoiler = this.toggleSpoiler.bind(this)
  }

  toggleSpoiler () {
    this.setState({ showContent: !this.state.showContent }, () => this.props.parentEl.classList.toggle('content-hidden'))
  }

  render (props, state) {
    return (
      <div className='spoiler-toggle-button' onClick={this.toggleSpoiler}>
        <span className={`${!state.showContent ? 'is-hidden' : ''}`}><Phrase m='Common' p='bb.spoiler.hide-content' /></span>
        <span className={`${state.showContent ? 'is-hidden' : ''}`}><Phrase m='Common' p='bb.spoiler.show-content' /></span>
      </div>
    )
  }
}
